import { getMonthNow } from "../../utils/getMonthNow";
import { getYearNow } from "../../utils/getYearNow";
import { types } from "../types/types";

const init = {
  proveedoresApi: [],
  enviandoProveedorApi: false,
  actividades: [],
  incidencias: [],
  elAguilaAuth: false,
  asistencia: {},
  proveedorCostos: {},
  asistencias: [],
  clientesCampanias: [],
  captura: {},
  capturaStep: 1,
  capturaCampos: [],
  servicios: { tipos: [], serviciosFinal: [] },
  validaInfo: {
    loading: true,
  },
  misServicios: [],
  serviciosByMes: [],
  newLatLng: { lat: 19.364612026633605, lng: -99.18838994738087 },
  esperandoSMS: 0,
  filtroAsistencia: {
    mes: getMonthNow() + 1,
    anio: getYearNow(),
  },
};
export const asistenciasReducer = (state = init, action) => {
  switch (action.type) {

    case types.setEnviandoProveedorApi:
      return {
        ...state,
        enviandoProveedorApi: action.payload,
      };

    case types.storeProveedoresApi:
      return {
        ...state,
        proveedoresApi: action.payload,
      };

    case types.storeIncidencias:
      return {
        ...state,
        incidencias: action.payload,
      };

    case types.storeActividades:
      return {
        ...state,
        actividades: action.payload,
      };

    case types.setElAguilaAuth:
      return {
        ...state,
        elAguilaAuth: action.payload,
      };

    case types.storeAsistenciaID:
      return {
        ...state,
        captura: {
          ...state.captura,
          asistenciaID: action.payload,
        },
      };
    case types.setFiltroAsistencia: {
      return {
        ...state,
        filtroAsistencia: {
          ...state.filtroAsistencia,
          ...action.payload,
        },
      };
    }

    case types.setEsperandoSMS:
      return {
        ...state,
        esperandoSMS: action.payload,
      };

    case types.setNewLatLng:
      return {
        ...state,
        newLatLng: action.payload,
      };
    case types.storeServiciosByMes:
      return {
        ...state,
        serviciosByMes: action.payload,
      };

    case types.storeMisServicios:
      return {
        ...state,
        misServicios: action.payload,
      };
    case types.cleanCaptura:
      return {
        ...state,
        captura: {},
        newLatLng: { lat: 19.364612026633605, lng: -99.18838994738087 },
        esperandoSMS: 0,
      };
    case types.storeValidadorInfo:
      return {
        ...state,
        validaInfo: { loading: false, ...action.payload },
      };

    case types.storeServicios:
      return {
        ...state,
        servicios: action.payload,
      };

    case types.setGeoDataOrigen:
      return {
        ...state,
        captura: {
          ...state.captura,
          ...action.payload,
        },
      };

    case types.setCapturaCampos:
      return {
        ...state,
        capturaCampos: action.payload,
      };
    case types.setCapturaStep:
      return {
        ...state,
        capturaStep: action.payload,
      };
    case types.setCaptura:
      return {
        ...state,
        captura: {
          ...state.captura,
          ...action.payload,
        },
      };
    case types.storeClientesCampanias:
      return {
        ...state,
        clientesCampanias: action.payload,
      };

    default:
      return state;
  }
};

////////////
